import { STATUS } from "src/constants/searchParams";

export type FilterType = {
  name: string;
  placeholder: string;
};

export const filters: FilterType[] = [
  {
    name: STATUS,
    placeholder: "Status",
  },
];

export const statuses = ["active", "inactive"];
